import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { RESUME_EVALUATION_ROUTER_PATH } from '@/constants/router-path';
import { trackClickEvent } from '@/utils/site-track';
import BannerImage from '@/assets/job-title/freepik.png';

const RightBanner = (props: { isLogin: boolean }) => {
  const { isLogin } = props;

  return (
    <div
      data-observer-id="marketing_right-banner_evaluation"
      data-ele-group="marketing_banner_evaluation"
      data-ele-id="right-banner_我的简历能拿到这个薪资吗？"
      className={`rounded-lg px-6 pb-3.5 bg-white text-center sticky ${isLogin ? 'top-16' : 'top-32'}`}
    >
      <div className="w-full h-[234px] relative">
        <Image
          alt=""
          src={BannerImage}
          fill
          style={{
            objectFit: 'contain',
          }}
        />
      </div>
      <p className="mb-2 text-xl font-semibold text-left text-web-black-100">
        经验与学历往往不等于机会——关键看你简历怎么写
      </p>
      <p className="text-sm leading-7 text-web-grey-600 pb-6 border-b border-b-web-tertiary">
        帮你挖掘隐藏优势，让职场价值被看见
      </p>
      <div className="mt-6 mb-2.5">
        <Link
          className="text-web-black-100 text-base font-semibold"
          href={RESUME_EVALUATION_ROUTER_PATH}
          onClick={trackClickEvent}
        >
          立即诊断简历
        </Link>
      </div>
    </div>
  );
};

export default RightBanner;
